import { render, staticRenderFns } from "./PageEight.vue?vue&type=template&id=5a3a9c4a&scoped=true"
import script from "./PageEight.vue?vue&type=script&lang=js"
export * from "./PageEight.vue?vue&type=script&lang=js"
import style0 from "./PageEight.vue?vue&type=style&index=0&id=5a3a9c4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3a9c4a",
  null
  
)

export default component.exports